import * as types from './types'

export const getCompanies = (payload: any) => ({
  type: types.GET_COMPANIES,
  payload,
})

export const startLoadingCompanies = () => ({
  type: types.START_LOADING_COMPANIES,
  payload: null,
})

export const stopLoadingCompanies = () => ({
  type: types.STOP_LOADING_COMPANIES,
  payload: null,
})
